import React from 'react';
import {
  StyledHeader,
  StyledTd,
} from '../../../Pages/Questionnaire/index.styles';
import { companiesColors } from '../../../Pages/SuperDashboard/data';
import CommentBtn from './commentBtn';
import TableButton from '../../TableButton';
import { toLocaleNumber } from '../../../../utils/helpers';

export default function EvConsumptionPreview({
  state,
  id,
  setActive,
  setState,
  language,
}: {
  state: any[];
  id: number;
  setActive: Function;
  setState: Function;
  language: string;
}) {
  const handleCopy = () => {
    const tempState = [...state];
    const item = tempState[id];

    tempState.splice(id, 0, item);
    setState(tempState);
    setActive(id);
  };
  return (
    <StyledHeader>
      <StyledTd width={25} color={companiesColors[id]}>
        <p>
          {state[id].electric_vehicle_energy_consumption_data_factor_unknown
            ?.name_label || ''}
        </p>
        <CommentBtn state={state} id={id} />
      </StyledTd>
      <StyledTd width={15} color={companiesColors[id]}>
        {toLocaleNumber(
          state[id].electric_vehicle_energy_consumption_data_factor_unknown
            ?.spending_pln_or_kwh_per_period ||
            state[id].electric_vehicle_energy_consumption_data_factor_known
              ?.amount,
          language
        )}
      </StyledTd>
      <StyledTd width={10} color={companiesColors[id]}>
        {state[id].electric_vehicle_energy_consumption_data_factor_unknown
          ?.unit ||
          state[id].electric_vehicle_energy_consumption_data_factor_known
            ?.unit_label}
      </StyledTd>
      <StyledTd width={20} color={companiesColors[id]}>
        {state[id].emission_shared
          ? (state[id].emission_shared * 100).toFixed(2)
          : 0}
      </StyledTd>
      <StyledTd width={20} color={companiesColors[id]}>
        {state[id].certified_energy_usage_data?.certified_percentge?.toFixed(
          2
        ) || 0}
      </StyledTd>
      <StyledTd
        width={0}
        color={companiesColors[id]}
        lastCallCustom
        numberOfIcons="two"
      >
        <TableButton hoverText="copy" icon="copy" onClick={handleCopy} />
        <TableButton
          hoverText="edit"
          icon="edit"
          onClick={() => setActive(id)}
        />
      </StyledTd>
    </StyledHeader>
  );
}
